import { render, staticRenderFns } from "./SaveLinkForm.vue?vue&type=template&id=bef4dae0"
import script from "./SaveLinkForm.vue?vue&type=script&lang=js"
export * from "./SaveLinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports